<!-- prettier-ignore -->
<!-- #region customCode: page-component-html__header__start -->

<!-- #endregion customCode: page-component-html__header__start -->

<!-- Container: Main Container -->
<div class="rappider-container main-container col-12">
  <!-- Container: Container 2 -->
  <div class="rappider-container container-2 col-12 p-0 m-0">
    <!-- Container: Container 3 -->
    <div
      class="rappider-container container-3 col-12 width-100-mw480 p-0 m-0 container menu-visibility-hide"
    >
      <div class="rappider-component">
        <!-- Component: Image 1 -->
        <rappider-image
          [source]="image_1.source"
          [alternateText]="image_1.alternateText"
          [placeholder]="image_1.placeholder"
          [disablePreview]="image_1.disablePreview"
          [borderSettings]="image_1.borderSettings"
          [shadowSettings]="image_1.shadowSettings"
          [paddingSettings]="image_1.paddingSettings"
          [marginSettings]="image_1.marginSettings"
          [customSizeSettings]="image_1.customSizeSettings"
        >
        </rappider-image>
      </div>

      <!-- Container: Container 4 -->
      <div class="rappider-container container-4 col-10 position-relative">
        <!-- Container: Container 5 -->
        <div class="rappider-container container-5 py-0">
          <div class="rappider-component p-0">
            <!-- Component: Button 2 -->
            <rappider-button
              [text]="button_2.text"
              [type]="button_2.type"
              [shape]="button_2.shape"
              [size]="button_2.size"
              [colorType]="button_2.colorType"
              [icon]="button_2.icon"
              [iconPlacement]="button_2.iconPlacement"
              [transparent]="button_2.transparent"
              [loading]="button_2.loading"
              [block]="button_2.block"
              [disabled]="button_2.disabled"
              [key]="button_2.key"
              [emitWithoutPopconfirm]="button_2.emitWithoutPopconfirm"
              [popconfirmTitle]="button_2.popconfirmTitle"
              [borderSettings]="button_2.borderSettings"
              [marginSettings]="button_2.marginSettings"
              [paddingSettings]="button_2.paddingSettings"
              [shadowSettings]="button_2.shadowSettings"
              [customColorSettings]="button_2.customColorSettings"
              [customSizeSettings]="button_2.customSizeSettings"
              (click)="button_2_click($event)"
            >
            </rappider-button>
          </div>

          <div class="rappider-component">
            <!-- Component: Button 3 -->
            <rappider-button
              [text]="button_3.text"
              [type]="button_3.type"
              [shape]="button_3.shape"
              [size]="button_3.size"
              [colorType]="button_3.colorType"
              [icon]="button_3.icon"
              [iconPlacement]="button_3.iconPlacement"
              [transparent]="button_3.transparent"
              [loading]="button_3.loading"
              [block]="button_3.block"
              [disabled]="button_3.disabled"
              [key]="button_3.key"
              [emitWithoutPopconfirm]="button_3.emitWithoutPopconfirm"
              [popconfirmTitle]="button_3.popconfirmTitle"
              [borderSettings]="button_3.borderSettings"
              [marginSettings]="button_3.marginSettings"
              [paddingSettings]="button_3.paddingSettings"
              [shadowSettings]="button_3.shadowSettings"
              [customColorSettings]="button_3.customColorSettings"
              [customSizeSettings]="button_3.customSizeSettings"
              (click)="button_3_click($event)"
            >
            </rappider-button>
          </div>
        </div>
      </div>
    </div>

    <!-- Container: Container 6 -->
    <div
      class="rappider-container container-6 col-12 container p-0 m-0 menu-visibility container-nowrap"
    >
      <div class="rappider-component">
        <!-- Component: Image 5 -->
        <rappider-image
          [source]="image_5.source"
          [alternateText]="image_5.alternateText"
          [placeholder]="image_5.placeholder"
          [disablePreview]="image_5.disablePreview"
          [borderSettings]="image_5.borderSettings"
          [shadowSettings]="image_5.shadowSettings"
          [paddingSettings]="image_5.paddingSettings"
          [marginSettings]="image_5.marginSettings"
          [customSizeSettings]="image_5.customSizeSettings"
        >
        </rappider-image>
      </div>

      <!-- Container: Container 7 -->
      <div class="rappider-container container-7">
        <div class="rappider-component">
          <!-- Component: Button 6 -->
          <rappider-button
            [text]="button_6.text"
            [type]="button_6.type"
            [shape]="button_6.shape"
            [size]="button_6.size"
            [colorType]="button_6.colorType"
            [icon]="button_6.icon"
            [iconPlacement]="button_6.iconPlacement"
            [transparent]="button_6.transparent"
            [loading]="button_6.loading"
            [block]="button_6.block"
            [disabled]="button_6.disabled"
            [key]="button_6.key"
            [emitWithoutPopconfirm]="button_6.emitWithoutPopconfirm"
            [popconfirmTitle]="button_6.popconfirmTitle"
            [borderSettings]="button_6.borderSettings"
            [marginSettings]="button_6.marginSettings"
            [paddingSettings]="button_6.paddingSettings"
            [shadowSettings]="button_6.shadowSettings"
            [customColorSettings]="button_6.customColorSettings"
            [customSizeSettings]="button_6.customSizeSettings"
            (click)="button_6_click($event)"
          >
          </rappider-button>
        </div>

        <div class="rappider-component">
          <!-- Component: Button 7 -->
          <rappider-button
            [text]="button_7.text"
            [type]="button_7.type"
            [shape]="button_7.shape"
            [size]="button_7.size"
            [colorType]="button_7.colorType"
            [icon]="button_7.icon"
            [iconPlacement]="button_7.iconPlacement"
            [transparent]="button_7.transparent"
            [loading]="button_7.loading"
            [block]="button_7.block"
            [disabled]="button_7.disabled"
            [key]="button_7.key"
            [emitWithoutPopconfirm]="button_7.emitWithoutPopconfirm"
            [popconfirmTitle]="button_7.popconfirmTitle"
            [borderSettings]="button_7.borderSettings"
            [marginSettings]="button_7.marginSettings"
            [paddingSettings]="button_7.paddingSettings"
            [shadowSettings]="button_7.shadowSettings"
            [customColorSettings]="button_7.customColorSettings"
            [customSizeSettings]="button_7.customSizeSettings"
          >
          </rappider-button>
        </div>
      </div>
    </div>
  </div>

  <div>
    <router-outlet></router-outlet>
  </div>

  <!-- Container: Container 1 -->
  <div class="rappider-container container-1 col-12 p-0 m-0">
    <!-- Container: Container 8 -->
    <div class="rappider-container container-8 col-12 p-0 container">
      <!-- Container: Container 9 -->
      <div
        class="rappider-container container-9 col-2 width-100-mw480 footer-container-settings"
      >
        <div class="rappider-component py-0">
          <!-- Component: Button 9 -->
          <rappider-button
            [text]="button_9.text"
            [type]="button_9.type"
            [shape]="button_9.shape"
            [size]="button_9.size"
            [colorType]="button_9.colorType"
            [icon]="button_9.icon"
            [iconPlacement]="button_9.iconPlacement"
            [transparent]="button_9.transparent"
            [loading]="button_9.loading"
            [block]="button_9.block"
            [disabled]="button_9.disabled"
            [key]="button_9.key"
            [emitWithoutPopconfirm]="button_9.emitWithoutPopconfirm"
            [popconfirmTitle]="button_9.popconfirmTitle"
            [borderSettings]="button_9.borderSettings"
            [marginSettings]="button_9.marginSettings"
            [paddingSettings]="button_9.paddingSettings"
            [shadowSettings]="button_9.shadowSettings"
            [customColorSettings]="button_9.customColorSettings"
            [customSizeSettings]="button_9.customSizeSettings"
            (click)="button_9_click($event)"
          >
          </rappider-button>
        </div>
      </div>

      <!-- Container: Container 10 -->
      <div
        class="rappider-container container-10 col-2 width-100-mw480 footer-container-settings"
      >
        <div class="rappider-component py-0">
          <!-- Component: Heading 11 -->
          <rappider-heading
            [content]="heading_11.content"
            [type]="heading_11.type"
          >
          </rappider-heading>
        </div>

        <div class="rappider-component py-0">
          <!-- Component: Button 15 -->
          <rappider-button
            [text]="button_15.text"
            [type]="button_15.type"
            [shape]="button_15.shape"
            [size]="button_15.size"
            [colorType]="button_15.colorType"
            [icon]="button_15.icon"
            [iconPlacement]="button_15.iconPlacement"
            [transparent]="button_15.transparent"
            [loading]="button_15.loading"
            [block]="button_15.block"
            [disabled]="button_15.disabled"
            [key]="button_15.key"
            [emitWithoutPopconfirm]="button_15.emitWithoutPopconfirm"
            [popconfirmTitle]="button_15.popconfirmTitle"
            [borderSettings]="button_15.borderSettings"
            [marginSettings]="button_15.marginSettings"
            [paddingSettings]="button_15.paddingSettings"
            [shadowSettings]="button_15.shadowSettings"
            [customColorSettings]="button_15.customColorSettings"
            [customSizeSettings]="button_15.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component py-0">
          <!-- Component: Button 17 -->
          <rappider-button
            [text]="button_17.text"
            [type]="button_17.type"
            [shape]="button_17.shape"
            [size]="button_17.size"
            [colorType]="button_17.colorType"
            [icon]="button_17.icon"
            [iconPlacement]="button_17.iconPlacement"
            [transparent]="button_17.transparent"
            [loading]="button_17.loading"
            [block]="button_17.block"
            [disabled]="button_17.disabled"
            [key]="button_17.key"
            [emitWithoutPopconfirm]="button_17.emitWithoutPopconfirm"
            [popconfirmTitle]="button_17.popconfirmTitle"
            [borderSettings]="button_17.borderSettings"
            [marginSettings]="button_17.marginSettings"
            [paddingSettings]="button_17.paddingSettings"
            [shadowSettings]="button_17.shadowSettings"
            [customColorSettings]="button_17.customColorSettings"
            [customSizeSettings]="button_17.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component py-0">
          <!-- Component: Button 18 -->
          <rappider-button
            [text]="button_18.text"
            [type]="button_18.type"
            [shape]="button_18.shape"
            [size]="button_18.size"
            [colorType]="button_18.colorType"
            [icon]="button_18.icon"
            [iconPlacement]="button_18.iconPlacement"
            [transparent]="button_18.transparent"
            [loading]="button_18.loading"
            [block]="button_18.block"
            [disabled]="button_18.disabled"
            [key]="button_18.key"
            [emitWithoutPopconfirm]="button_18.emitWithoutPopconfirm"
            [popconfirmTitle]="button_18.popconfirmTitle"
            [borderSettings]="button_18.borderSettings"
            [marginSettings]="button_18.marginSettings"
            [paddingSettings]="button_18.paddingSettings"
            [shadowSettings]="button_18.shadowSettings"
            [customColorSettings]="button_18.customColorSettings"
            [customSizeSettings]="button_18.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component py-0">
          <!-- Component: Button 19 -->
          <rappider-button
            [text]="button_19.text"
            [type]="button_19.type"
            [shape]="button_19.shape"
            [size]="button_19.size"
            [colorType]="button_19.colorType"
            [icon]="button_19.icon"
            [iconPlacement]="button_19.iconPlacement"
            [transparent]="button_19.transparent"
            [loading]="button_19.loading"
            [block]="button_19.block"
            [disabled]="button_19.disabled"
            [key]="button_19.key"
            [emitWithoutPopconfirm]="button_19.emitWithoutPopconfirm"
            [popconfirmTitle]="button_19.popconfirmTitle"
            [borderSettings]="button_19.borderSettings"
            [marginSettings]="button_19.marginSettings"
            [paddingSettings]="button_19.paddingSettings"
            [shadowSettings]="button_19.shadowSettings"
            [customColorSettings]="button_19.customColorSettings"
            [customSizeSettings]="button_19.customSizeSettings"
          >
          </rappider-button>
        </div>
      </div>

      <!-- Container: Container 11 -->
      <div
        class="rappider-container container-11 col-2 width-100-mw480 footer-container-settings"
      >
        <div class="rappider-component py-0">
          <!-- Component: Heading 20 -->
          <rappider-heading
            [content]="heading_20.content"
            [type]="heading_20.type"
          >
          </rappider-heading>
        </div>

        <div class="rappider-component py-0">
          <!-- Component: Button 22 -->
          <rappider-button
            [text]="button_22.text"
            [type]="button_22.type"
            [shape]="button_22.shape"
            [size]="button_22.size"
            [colorType]="button_22.colorType"
            [icon]="button_22.icon"
            [iconPlacement]="button_22.iconPlacement"
            [transparent]="button_22.transparent"
            [loading]="button_22.loading"
            [block]="button_22.block"
            [disabled]="button_22.disabled"
            [key]="button_22.key"
            [emitWithoutPopconfirm]="button_22.emitWithoutPopconfirm"
            [popconfirmTitle]="button_22.popconfirmTitle"
            [borderSettings]="button_22.borderSettings"
            [marginSettings]="button_22.marginSettings"
            [paddingSettings]="button_22.paddingSettings"
            [shadowSettings]="button_22.shadowSettings"
            [customColorSettings]="button_22.customColorSettings"
            [customSizeSettings]="button_22.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component py-0">
          <!-- Component: Button 24 -->
          <rappider-button
            [text]="button_24.text"
            [type]="button_24.type"
            [shape]="button_24.shape"
            [size]="button_24.size"
            [colorType]="button_24.colorType"
            [icon]="button_24.icon"
            [iconPlacement]="button_24.iconPlacement"
            [transparent]="button_24.transparent"
            [loading]="button_24.loading"
            [block]="button_24.block"
            [disabled]="button_24.disabled"
            [key]="button_24.key"
            [emitWithoutPopconfirm]="button_24.emitWithoutPopconfirm"
            [popconfirmTitle]="button_24.popconfirmTitle"
            [borderSettings]="button_24.borderSettings"
            [marginSettings]="button_24.marginSettings"
            [paddingSettings]="button_24.paddingSettings"
            [shadowSettings]="button_24.shadowSettings"
            [customColorSettings]="button_24.customColorSettings"
            [customSizeSettings]="button_24.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component py-0">
          <!-- Component: Button 26 -->
          <rappider-button
            [text]="button_26.text"
            [type]="button_26.type"
            [shape]="button_26.shape"
            [size]="button_26.size"
            [colorType]="button_26.colorType"
            [icon]="button_26.icon"
            [iconPlacement]="button_26.iconPlacement"
            [transparent]="button_26.transparent"
            [loading]="button_26.loading"
            [block]="button_26.block"
            [disabled]="button_26.disabled"
            [key]="button_26.key"
            [emitWithoutPopconfirm]="button_26.emitWithoutPopconfirm"
            [popconfirmTitle]="button_26.popconfirmTitle"
            [borderSettings]="button_26.borderSettings"
            [marginSettings]="button_26.marginSettings"
            [paddingSettings]="button_26.paddingSettings"
            [shadowSettings]="button_26.shadowSettings"
            [customColorSettings]="button_26.customColorSettings"
            [customSizeSettings]="button_26.customSizeSettings"
          >
          </rappider-button>
        </div>

        <div class="rappider-component py-0">
          <!-- Component: Button 28 -->
          <rappider-button
            [text]="button_28.text"
            [type]="button_28.type"
            [shape]="button_28.shape"
            [size]="button_28.size"
            [colorType]="button_28.colorType"
            [icon]="button_28.icon"
            [iconPlacement]="button_28.iconPlacement"
            [transparent]="button_28.transparent"
            [loading]="button_28.loading"
            [block]="button_28.block"
            [disabled]="button_28.disabled"
            [key]="button_28.key"
            [emitWithoutPopconfirm]="button_28.emitWithoutPopconfirm"
            [popconfirmTitle]="button_28.popconfirmTitle"
            [borderSettings]="button_28.borderSettings"
            [marginSettings]="button_28.marginSettings"
            [paddingSettings]="button_28.paddingSettings"
            [shadowSettings]="button_28.shadowSettings"
            [customColorSettings]="button_28.customColorSettings"
            [customSizeSettings]="button_28.customSizeSettings"
          >
          </rappider-button>
        </div>
      </div>

      <!-- Container: Container 12 -->
      <div
        class="rappider-container container-12 col-2 width-100-mw480 footer-container-settings"
      >
        <!-- Container: Container 13 -->
        <div
          class="rappider-container container-13 col-12 p-0 m-0 border-bottom footer-container-settings"
        >
          <div class="rappider-component py-0">
            <!-- Component: Heading 29 -->
            <rappider-heading
              [content]="heading_29.content"
              [type]="heading_29.type"
            >
            </rappider-heading>
          </div>

          <div class="rappider-component py-0">
            <!-- Component: Button 30 -->
            <rappider-button
              [text]="button_30.text"
              [type]="button_30.type"
              [shape]="button_30.shape"
              [size]="button_30.size"
              [colorType]="button_30.colorType"
              [icon]="button_30.icon"
              [iconPlacement]="button_30.iconPlacement"
              [transparent]="button_30.transparent"
              [loading]="button_30.loading"
              [block]="button_30.block"
              [disabled]="button_30.disabled"
              [key]="button_30.key"
              [emitWithoutPopconfirm]="button_30.emitWithoutPopconfirm"
              [popconfirmTitle]="button_30.popconfirmTitle"
              [borderSettings]="button_30.borderSettings"
              [marginSettings]="button_30.marginSettings"
              [paddingSettings]="button_30.paddingSettings"
              [shadowSettings]="button_30.shadowSettings"
              [customColorSettings]="button_30.customColorSettings"
              [customSizeSettings]="button_30.customSizeSettings"
            >
            </rappider-button>
          </div>

          <div class="rappider-component py-0">
            <!-- Component: Button 31 -->
            <rappider-button
              [text]="button_31.text"
              [type]="button_31.type"
              [shape]="button_31.shape"
              [size]="button_31.size"
              [colorType]="button_31.colorType"
              [icon]="button_31.icon"
              [iconPlacement]="button_31.iconPlacement"
              [transparent]="button_31.transparent"
              [loading]="button_31.loading"
              [block]="button_31.block"
              [disabled]="button_31.disabled"
              [key]="button_31.key"
              [emitWithoutPopconfirm]="button_31.emitWithoutPopconfirm"
              [popconfirmTitle]="button_31.popconfirmTitle"
              [borderSettings]="button_31.borderSettings"
              [marginSettings]="button_31.marginSettings"
              [paddingSettings]="button_31.paddingSettings"
              [shadowSettings]="button_31.shadowSettings"
              [customColorSettings]="button_31.customColorSettings"
              [customSizeSettings]="button_31.customSizeSettings"
            >
            </rappider-button>
          </div>
        </div>

        <!-- Container: Container 14 -->
        <div
          class="rappider-container container-14 col-12 p-0 m-0 footer-container-settings"
        >
          <div class="rappider-component py-0">
            <!-- Component: Heading 32 -->
            <rappider-heading
              [content]="heading_32.content"
              [type]="heading_32.type"
            >
            </rappider-heading>
          </div>

          <!-- Container: Container 15 -->
          <div
            class="rappider-container container-15 col-12 gap-3 p-0 footer-container-settings"
          >
            <div class="rappider-component button-42">
              <!-- Component: Button 42 -->
              <rappider-button
                [text]="button_42.text"
                [type]="button_42.type"
                [shape]="button_42.shape"
                [size]="button_42.size"
                [colorType]="button_42.colorType"
                [icon]="button_42.icon"
                [iconPlacement]="button_42.iconPlacement"
                [transparent]="button_42.transparent"
                [loading]="button_42.loading"
                [block]="button_42.block"
                [disabled]="button_42.disabled"
                [key]="button_42.key"
                [emitWithoutPopconfirm]="button_42.emitWithoutPopconfirm"
                [popconfirmTitle]="button_42.popconfirmTitle"
                [borderSettings]="button_42.borderSettings"
                [marginSettings]="button_42.marginSettings"
                [paddingSettings]="button_42.paddingSettings"
                [shadowSettings]="button_42.shadowSettings"
                [customColorSettings]="button_42.customColorSettings"
                [customSizeSettings]="button_42.customSizeSettings"
                [redirectUrl]="button_42.redirectUrl"
                [redirectTarget]="button_42.redirectTarget"
              >
              </rappider-button>
            </div>
          </div>

          <div class="rappider-component py-0">
            <!-- Component: Text 37 -->
            <rappider-text
              [textMode]="text_37.textMode"
              [text]="text_37.text"
              [content]="text_37.content"
              [typography]="text_37.typography"
              [colorSettings]="text_37.colorSettings"
            >
            </rappider-text>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- prettier-ignore -->
<!-- #region customCode: page-component-html__footer__end -->

<!-- #endregion customCode: page-component-html__footer__end -->
